import styled from 'styled-components';
import Icon from '../../assets/images/sms.svg';

interface SmsIconProps {
  fill: string;
}

const SmsIcon = styled.span<SmsIconProps>`
  ${({fill}) => `
        background-color: ${fill};
        display: inline-block;
        height: 40px;
        mask-image: url(${Icon});
        mask-position: center center;
        mask-repeat: no-repeat;
        mask-size: 100%;
        position:relative;
        width: 38px;
    `}
`;

export default SmsIcon;
